(function () {
  const Product = {   
    imageLoaded: function(targetElements, callback) {
      this.forEachElement(targetElements, function (image) {
        if (image.tagName !== 'IMG') {
          return false;
        }
        if (image.complete) {
          callback();
        } else {
          image.addEventListener('load', callback);
        }
      });
    },    
    getElementsFromVar: function (elementsTarget, firstItem) {
      if (!elementsTarget) {
        return firstItem ? undefined : [];
      }
      if (typeof elementsTarget === 'string') {
        elementsTarget = document.querySelectorAll(elementsTarget);
      }
      if (firstItem) {
        return elementsTarget instanceof HTMLElement ? elementsTarget : elementsTarget[0];
      } else {
        return elementsTarget instanceof HTMLElement ? [elementsTarget] : elementsTarget;
      }
    },    
    forEachElement: function (targetElements, callback) {
      targetElements = this.getElementsFromVar(targetElements, false);
      for (let i = 0; i < targetElements.length; i++) {
        callback(targetElements[i], i);
      }
    }
  }

  const initZoom = (containerSelector) => {
    if (window.outerWidth <= 768) {
      return;
    }

    document.querySelectorAll(containerSelector).forEach(function (container) {
      const img = container.querySelector('img');
      Product.imageLoaded(img, function () {
        if (img.naturalWidth >= 800) {
          new ImageZoom(container, {
            fillContainer: true,
            zoomPosition: 'original',
            gap: 20,
          })
        }
      });
    });
  }

  const initProductCarousel = () => {
    var thumbnailsSelector = '.js--section-product__thumbnails';
    var carouselGlide = new Glide('.js--section-product__slider', {
      type: 'carousel',
      startAt: 0,
      perView: 1,
    });

    var thumbnailGlide = new Glide(thumbnailsSelector, {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      focusAt: 0,
      gap: 10,
    });

    carouselGlide.on('run', function () {
      if (carouselGlide.index == thumbnailGlide.index) {
        return;
      }

      thumbnailGlide.go('=' + carouselGlide.index);
    });

    carouselGlide.on('run.after', function () {
      initZoom('.js--section-product__slider-item.glide__slide--active');
    });

    carouselGlide.mount();

    initZoom('.js--section-product__slider-item.glide__slide--active');

    const setActiveThumbnail = function (selectedIndex) {
      var activeThumbnails = document.querySelectorAll('.section-product__thumb-item--active');
      for (var i = 0; i < activeThumbnails.length; i++) {
        activeThumbnails[i].classList.remove('section-product__thumb-item--active');
      }
      var selectedThumbnails = document.querySelectorAll(
      thumbnailsSelector +
      ' ' +
      '.section-product__thumb-item[data-img-number="' +
      selectedIndex +
      '"]'
      );

      for (var i = 0; i < selectedThumbnails.length; i++) {
       selectedThumbnails[i].classList.add('section-product__thumb-item--active');
      }
      
    }

    var didUpdateThumbnailSettings = false;
    thumbnailGlide.on('build.after', function () {
      var thumbnailContainerElements = document.querySelectorAll('.section-product__thumb-item');
      for (var i = 0; i < thumbnailContainerElements.length; i++) {
        thumbnailContainerElements[i].addEventListener('click', function (e) {
          thumbnailGlide.go('=' + this.dataset.imgNumber);
        });
      }
      setActiveThumbnail(thumbnailGlide.index);
      if (!didUpdateThumbnailSettings) {
        setTimeout(function () {
          // For some reason Glide.js doesn't always calculate the width for three
          // elements per page correctly on the first try.
          thumbnailGlide.update(thumbnailGlide.settings);
          didUpdateThumbnailSettings = true;
        }, 300);
      }
    })

    thumbnailGlide.on('run', function () {
      setActiveThumbnail(thumbnailGlide.index);
      if (carouselGlide.index == thumbnailGlide.index) {
        return;
      }

      carouselGlide.go('=' + thumbnailGlide.index);
    });

    thumbnailGlide.mount();

    const prevButton = document.querySelector(thumbnailsSelector + ' .section-product__slider-arrow-left');
    const nextButton = document.querySelector(thumbnailsSelector + ' .section-product__slider-arrow-right');
    
    prevButton?.addEventListener('click', () => {
      thumbnailGlide.go('<')
    })
    nextButton?.addEventListener('click', () => {
      thumbnailGlide.go('>')
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductCarousel();
  });
})();